import {useNavigate, useSearchParams} from "react-router-dom";
import React, {Suspense, useEffect, useState} from "react";
import Loading from "../../components/loading";
import './custom.css'
import stringHelper from "../../helpers/string-helper";
import MiniSlider from "./mini-slider";
import MiniBanners from "./mini-banners";

import HomepageCasinoGroups from "./group";

const ProviderSlide = React.lazy(() => import("../../components/providers-slide"));

const HomepageSlider = React.lazy(() => import("./slider"));
const LastPlayedGames = React.lazy(() => import("../../components/last-played-games"));
const GeneralDebitStats = React.lazy(() => import("../../components/debit-table/general-debit-stats"));


const Homepage = () => {
    // const {activeLanguage, agent} = useSelector(state => state.globalReducer)

    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    // const {i18n} = useTranslation();
    // const currentLanguage = i18n.language; // Get the current language


    const handleRegister = () =>
        navigate(stringHelper.getModalPath('register', searchParams))


    return (
        <>


            <Suspense fallback={<Loading/>}>
                <HomepageSlider handleRegister={handleRegister}/>
            </Suspense>

            <MiniBanners/>

            <Suspense fallback={<Loading/>}>
                <LastPlayedGames/>
            </Suspense>




            <Suspense fallback={<Loading/>}>
                <MiniSlider page={'homepage'}/>
            </Suspense>



            <HomepageCasinoGroups/>





            <Suspense fallback={<Loading/>}>
                <GeneralDebitStats/>
            </Suspense>


            <Suspense fallback={<Loading/>}>
                <ProviderSlide/>
            </Suspense>

        </>

    )

}

export default Homepage
